import { useNavigate } from 'react-router';
import errorImgMobile from '../../assets/imgs/error-page-img-mobile.png';
import errorImg from '../../assets/imgs/error-page-img.png';
import { NavBar } from '../../components/nav-footer/NavBar';
import { useWindowSize } from '../../hooks/useWindowSize';
import styles from './errorElement.module.css';

export const ErrorElement = () => {
  const size = useWindowSize();
  const navigate = useNavigate();
  return (
    <div className={styles.errorElement}>
      <NavBar />
      <div className={styles.errorElementPosition}>
        <div className={styles.errorElementText}>
          <p>Yikes! How&apos;d you get here?</p>
          <p>
            It&apos;s probably best you turn back. Exploring the unknown without
            the proper equipment can be dangerous. The page you are looking for
            most likely doesn&apos;t exist
          </p>
          <button
            onClick={() => navigate('')}
            className={styles.errorElementButton}>
            Let&apos;s get you back home
          </button>
        </div>
        <img
          className={styles.errorElementImg}
          src={size.width > 800 ? errorImg : errorImgMobile}
          alt="Error image"
        />
      </div>
    </div>
  );
};
